export default __webpack_public_path__ + "static/media/Save_Image.e09c5395.PNG";